/**
 * @generated SignedSource<<09779527e9909cd5cb7cfffde09e46ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type CurriculumLessonsFilterInput = {
  hasExitSlip?: boolean | null | undefined;
  isActive: ActiveRecords;
  lessonNames?: ReadonlyArray<string> | null | undefined;
  lessonNumbers?: ReadonlyArray<string> | null | undefined;
  skillIds?: ReadonlyArray<string> | null | undefined;
  targetGroupId?: string | null | undefined;
  targetIds?: ReadonlyArray<string> | null | undefined;
};
export type SingleUnitGetCurriculumLessonsQuery$variables = {
  filter?: CurriculumLessonsFilterInput | null | undefined;
  skip: boolean;
};
export type SingleUnitGetCurriculumLessonsQuery$data = {
  readonly curriculumLessons?: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null | undefined;
    readonly number: string | null | undefined;
    readonly skills: ReadonlyArray<{
      readonly id: string;
    } | null | undefined> | null | undefined;
  }>;
};
export type SingleUnitGetCurriculumLessonsQuery = {
  response: SingleUnitGetCurriculumLessonsQuery$data;
  variables: SingleUnitGetCurriculumLessonsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "concreteType": "CurriculumLessonNode",
        "kind": "LinkedField",
        "name": "curriculumLessons",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "number",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "skills",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SingleUnitGetCurriculumLessonsQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SingleUnitGetCurriculumLessonsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "db17e4406259ff196e832f7c963b6224",
    "id": null,
    "metadata": {},
    "name": "SingleUnitGetCurriculumLessonsQuery",
    "operationKind": "query",
    "text": "query SingleUnitGetCurriculumLessonsQuery(\n  $filter: CurriculumLessonsFilterInput\n  $skip: Boolean!\n) {\n  curriculumLessons(filter: $filter) @skip(if: $skip) {\n    id\n    number\n    name\n    skills {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cd60807901962d7ab61cd05268acfa16";

export default node;
